import { ReactNode, useContext, useEffect } from "react";
import InfoIcon from "../../assets/img/info.svg";
import "./ToastAlert.scss";
import Svg from "../../Svg/Svg";
import getClasses from "../../utils/getClasses";
import React, { createContext, useState } from "react";
import { DURATION_TOAST } from "../../utils/costants";

interface ToastSettings {
  subMessage?:
    | string
    | ((props: { onClose: () => void }) => ReactNode | JSX.Element);
  onClose?: () => void;
  message?: string | ReactNode | JSX.Element;
  duration?: number;
  type?: "success" | "error" | "warning" | "info";
}
interface ToastAlertType {
  myObject: ToastSettings[];
  updateObject: (newObject: ToastSettings[]) => void;
}

const ToastAlert = createContext<ToastAlertType | undefined>(undefined);
interface Iprops {
  children: React.ReactNode;
}
export const ProviderToastAlert: React.FC<Iprops> = ({ children }: Iprops) => {
  const [myObject, setMyObject] = useState<ToastSettings[]>([]);

  const updateObject = (newObject: ToastSettings[]) => {
    setMyObject(newObject);
  };

  return (
    <ToastAlert.Provider value={{ myObject, updateObject }}>
      {children}
    </ToastAlert.Provider>
  );
};

export const Toast: React.FC = () => {
  const context = useContext(ToastAlert);
  const isElement = (
    element:
      | string
      | ((props: { onClose: () => void }) => ReactNode | JSX.Element)
  ): element is (props: { onClose: () => void }) => ReactNode | JSX.Element =>
    typeof element !== "string";
  const closeToast = (id: number) => {
    context?.updateObject(context?.myObject.slice(id));
  };

  useEffect(() => {
    if (context && context.myObject.length > 0) {
      const timer = setTimeout(() => {
        context.updateObject(context.myObject.slice(1));
      }, DURATION_TOAST);

      return () => clearTimeout(timer);
    }
  }, [context]);
  return (
    <div className="container-toast">
      {context?.myObject.map(
        ({ subMessage, message, type, onClose }, index) => {
          return (
            <div
              key={index}
              className={`custom-toast-alert  custom-toast-alert-${type}`}
            >
              {typeof message === "string" ? (
                <div
                  className={`message-container ${getClasses({
                    "margin-sub": Boolean(subMessage),
                  })}`}
                >
                  <div className="d-flex align-items-center">
                    <Svg
                      className={`icon-toast-alert-info icon-toast-alert-info-${type}`}
                      icon={
                        type === "success"
                          ? `${InfoIcon}#info`
                          : `${InfoIcon}#info`
                      }
                    />
                    <h5 className="message">{message}</h5>
                  </div>
                  {Boolean(subMessage) && isElement(subMessage!) ? (
                    <>
                      {subMessage &&
                        isElement(subMessage) &&
                        onClose &&
                        subMessage({ onClose })}
                    </>
                  ) : (
                    <h5 className="sub-message">
                      {typeof subMessage === "string" && subMessage}
                    </h5>
                  )}
                </div>
              ) : (
                message
              )}
              <i
                onClick={() => (onClose ? onClose() : closeToast(index))}
                className={`icon icon-close`}
              />
            </div>
          );
        }
      )}
    </div>
  );
};

export const useToastAlert = () => {
  const context = useContext(ToastAlert);

 const showToast = (props: ToastSettings | ToastSettings[]) => {
  const newAlerts = Array.isArray(props) ? props : [props];
  context && context.updateObject([...context.myObject, ...newAlerts]);
};
  return { showToast };
};
